<template>
  <section
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    class="sepac-section-trust"
    :class="getPflegeColornameFromHex(props.blok.backgroundColor.value)"
  >
    <div>
      <div class="top">
        <header v-if="props.blok.heading || props.blok.copy">
          <h2>{{ props.blok.heading }}</h2>
        </header>
        <div>
          <SepacRichtextResolver :blok="props.blok.copy" />
        </div>
        <footer v-if="props.blok.btns.length > 0">
          <Button v-for="button in props.blok.btns" :key="button._uid" :blok="button" />
        </footer>
      </div>
      <SepacSectionTrustItem v-for="currentBlok in props.blok.items" :key="currentBlok._uid" :blok="currentBlok" />
    </div>
  </section>
</template>

<script setup>
import { WPElementButton } from '@webcarelbj/shared-bloks'
import { findComponent } from '@webcarelbj/shared-components'

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})

const Button = findComponent(WPElementButton)
const { getPflegeColornameFromHex } = usePflegeUtils()
</script>

<style scoped>
.sepac-section-trust {
  max-width: var(--maxContainerWidth);
  margin-inline: auto;
  padding-bottom: 3rem;

  & > div {
    display: grid;
    gap: 2rem;
    max-width: var(--maxContainerChildWidth);
    margin-inline: auto;
    padding-inline: .5rem;

    & > .top {
      display: grid;
      gap: 2rem;
      padding-block: 1.33rem;
      width: 100%;
    }
  }
}

@media (width < 576px) {
  footer {
    text-align: center;
  }
}
</style>